function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
define('TescoMobile_Checkout/js/view/choices-modal-perks',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'Magento_Catalog/js/price-utils', '../action/get-family-perks', '../action/save-family-perk', 'Magento_Checkout/js/model/quote', 'Magento_Customer/js/customer-data', 'Magento_Customer/js/model/customer', 'TescoMobile_Checkout/js/model/insurance', 'underscore', 'moment', 'mage/translate'], function (Component, $, ko, modal, priceUtils, getFamilyPerksAction, saveFamilyPerkAction, quote, customerData, customer, insuranceModel, _, moment) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    isLoading: ko.observable(false),
    modalTopContent: '',
    modalTopInsuranceContent: '',
    quoteItemId: null,
    anyInsurancePerkAvailable: ko.observable(false),
    updated: false,
    perks: ko.observableArray(),
    currentPerkSku: ko.observable(),
    messages: ko.observableArray(),
    insuranceRelatedPerkNewItemIdCaptured: false,
    familyPerksExists: ko.observable(false),
    loadEnd: ko.observable(false),
    insuranceUpdated: ko.observable(false),
    insuranceRelatedPerkRemoved: ko.observable(false),
    initialize: function () {
      this._super();
      this.allPerksSelected = ko.computed(function () {
        const selectedPerkIds = this.currentPerkSku() ? Object.entries(this.currentPerkSku()).filter(_ref => {
          let _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          return value !== false;
        }).map(_ref3 => {
          let _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          return parseInt(key);
        }) : [];
        const perkIds = this.perks().map(perk => perk.quoteId);
        const diff = _.difference(perkIds, selectedPerkIds);
        const value = perkIds.length > 0 && selectedPerkIds.length > 0 && diff.length === 0;
        if (this.modalWindow) {
          var _$, _$2;
          (_$ = $(this.modalWindow)) === null || _$ === void 0 || (_$ = _$.closest('.modal-popup')) === null || _$ === void 0 ? void 0 : _$.find('.action-close').toggle(value);
          (_$2 = $(this.modalWindow)) === null || _$2 === void 0 || (_$2 = _$2.find('.action.primary')) === null || _$2 === void 0 ? void 0 : _$2.prop('disabled', !value);
        }
        return value;
      }.bind(this));
    },
    setModalElement: function (element) {
      var self = this,
        cartData = customerData.get('cart');
      var options = {
        buttons: [{
          text: $.mage.__('OK'),
          class: '',
          attr: {},
          click: function (event) {
            self.messages([]);
          }
        }],
        modalClass: 'percs-modal',
        innerScroll: true,
        type: 'popup',
        clickableOverlay: false,
        closed: function () {
          self.loadEnd(false);
          if (self.updated === true) {
            $('body').loader('show');
            location.reload();
          }
        }
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      this.familyPerksExists($('.sub-item.family-perks-item').length > 0);
      if (this.familyPerksExists()) {
        this.loadEnd.subscribe(function (value) {
          if (value) {
            $(self.modalWindow).modal('openModal');
          }
        });
      }
      this.initEvents();
      this.initOpenModalEvents(element);
      $('body').trigger('perk-set-model-element');
    },
    initOpenModalEvents: function (element) {
      let self = this;
      $('body').on('perksOpenTrigger', function (event) {
        self.initPopupCart(element);
      });
      $(this.modalTrigger).on('click', function (event) {
        self.initPopupCart(element);
      });
      if (parseInt(self.canUnlockPerks) === 1) {
        $(document).on('insuranceSaved', function (e, data_id) {
          if (self.productAdded == true || self.insuranceRelatedPerkRemoved() === true || self.deviceUpdated === true) {
            $('body').trigger('perksOpenTrigger');
          } else {
            $('body').loader('show');
            location.reload();
          }
        });
      }
      $(document).on('insuranceClosed', function () {
        if (self.familyPerksExists() && parseInt(self.canUnlockPerks) === 1 && (self.productAdded == true || self.deviceUpdated === true) && self.insuranceUpdated != true) {
          $('body').trigger('perksOpenTrigger');
        } else if (self.insuranceUpdated() == true && self.productAdded != true && self.insuranceRelatedPerkRemoved() === false && self.deviceUpdated === false) {
          $('body').loader('show');
          location.reload();
        }
      });
      if (self.tariffUpdated && parseInt(self.canUnlockPerks) === 1 || self.lastProductHasInsurance === false && parseInt(self.anyOtherProductHasInsurance) === 1 || self.lastProductHasInsurance === false && parseInt(self.lastQuoteItemId) !== 0 && parseInt(self.canUnlockPerks) === 1 && parseInt(self.anyOtherProductHasInsurance) !== 1) {
        $('body').trigger('perksOpenTrigger');
      }
    },
    initEvents: function () {
      let self = this;
      $(document).on('insurance-changed', function () {
        self.insuranceUpdated(true);
      });
      $(document).on('insurance-related-perk-removed', function () {
        self.insuranceRelatedPerkRemoved(true);
      });
    },
    initPopupCart: function (element) {
      let onLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      let data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var quoteData = customerData.get('cart');
      $('body').loader('show');
      var cartData = onLoad ? data : quoteData().items,
        self = this,
        index = 2;
      if (typeof cartData === "undefined") {
        cartData = quote.getItems();
      }
      if (customer.isLoggedIn()) {
        var _quote$getData;
        var subs = this.activeSubsCount;
        if (((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_quote_type) === 'UPGRADE') {
          subs--;
        }
        if (Number(subs) + Number(cartData.length) <= 1) {
          cartData = [];
        }
        index = 1;
      }
      if (cartData && cartData.length > 0) {
        var itemAdded = cartData[cartData.length - index];
        if (itemAdded) {
          self.perks([]);
          self.messages([]);
          var deferred = $.Deferred();
          getFamilyPerksAction(deferred);
          $.when(deferred).done(function (result) {
            var selected = false,
              temp;
            if (result.length > 0) {
              let perks = [];
              result.forEach(function (item) {
                item.perks.forEach(function (perk) {
                  if (perk.selected == 1) {
                    temp = self.currentPerkSku() ? self.currentPerkSku() : {};
                    temp[item.item_id] = perk.sku;
                    self.currentPerkSku(temp);
                    $('.percs-modal .actions-holder button').prop("disabled", false);
                    selected = true;
                  }
                  if (perk.allowances && perk.allowances[0] && perk.allowances[0].allowance_type === 'insdisc' && perk.disabled === false) {
                    self.anyInsurancePerkAvailable(true);
                  }
                });
                if (!selected) {
                  temp = self.currentPerkSku() ? self.currentPerkSku() : {};
                  temp[item.item_id] = false;
                  self.currentPerkSku(temp);
                }
                perks.push({
                  'name': item.item_name,
                  'quoteId': item.item_id,
                  'items': item.perks
                });
              });
              this.perks(perks);
              $('body').loader('hide');
              this.loadEnd(true);
              $(this.addInsuranceTrigger).on('click', function (event) {
                insuranceModel.quoteItemId = $(event.target).attr('quote_item_id');
                $('.sub-item.insurance-item[data-quote-item-id=' + $(event.target).attr('quote_item_id') + ']').find('.insurance-change').trigger('click');
                this.closePerks();
              }.bind(this));
            }
          }.bind(this)).fail(function (response) {
            if (response && response.message) {
              self.isLoading(false);
              self.messages([{
                type: 'error',
                text: $.mage.__(response.message)
              }]);
            }
          }.bind(this));
        }
      }
      return true;
    },
    closePerks: function () {
      $(this.modalWindow).modal('closeModal');
      $('body').trigger('perks-closed');
      if (this.updated === true) {
        $('body').loader('show');
        location.reload();
      }
    },
    selectPerk: function (quoteItemId, perk) {
      var currentPerkSku = this.currentPerkSku();
      currentPerkSku[quoteItemId] = perk.sku;
      this.currentPerkSku(currentPerkSku);
      this._updateDivChangePerks(quoteItemId, perk);
      this.saveFamilyPerk(quoteItemId, perk.sku);
      this.updated = true;
      return true;
    },
    _updateDivChangePerks: function (quoteItemId, perk) {
      if (quoteItemId && $('.family-perks-item[data-quote-item-id="' + quoteItemId + '"]').length) {
        $('.family-perks-item[data-quote-item-id="' + quoteItemId + '"]').data('current-perk-sku', perk.sku).attr('data-current-perk-sku', perk.sku);
      }
    },
    saveFamilyPerk: function (quoteItemId, perkSku) {
      this.isLoading(true);
      var self = this;
      self.messages([]);
      var deferred = $.Deferred();
      deferred.done(function (response) {
        this.isLoading(false);
        if (response) {
          self._updateDivQuoteItemId(quoteItemId, response.id);
        }
      }.bind(this)).fail(function (response) {
        if (response.message) {
          self.isLoading(false);
          self.messages([{
            type: 'error',
            text: $.mage.__(response.message)
          }]);
        }
      }.bind(this));
      saveFamilyPerkAction(quoteItemId, perkSku, false, deferred);
    },
    _updateDivQuoteItemId: function (prevQuoteItemId, quoteItemId) {
      this.perks().map(function (item) {
        if (item.quoteId === prevQuoteItemId) {
          item.quoteId = quoteItemId;
        }
        return item;
      });
      if (prevQuoteItemId && $('.family-perks-item[data-quote-item-id="' + prevQuoteItemId + '"]').length) {
        $('.family-perks-item[data-quote-item-id="' + prevQuoteItemId + '"]').data('quote-item-id', quoteItemId).attr('data-quote-item-id', quoteItemId);
      }
    },
    getPerkSkuByQuoteItemId: function (quoteItemId) {
      var perkSku = this.currentPerkSku();
      if (_.isUndefined(perkSku)) {
        return false;
      }
      return !_.isUndefined(perkSku[quoteItemId]) ? perkSku[quoteItemId] : '';
    }
  });
});

